module.exports = __webpack_public_path__ + "static/media/paella.cfe6172d.jpg";